export const DELETE_ALL_PRODUCTS_CONFIRMATION = 'DELETAR TODOS OS PRODUTOS';

export const isDeleteAllProductsConfirmationValid = (value) => (
  String(value || '') === DELETE_ALL_PRODUCTS_CONFIRMATION
);

export const normalizeDeleteAllProductsPreview = (preview = {}) => ({
  ...preview,
  digest: String(preview.digest || ''),
  storedProductCount: Math.max(0, Number(preview.storedProductCount || 0)),
  activeProductCount: Math.max(0, Number(preview.activeProductCount || 0)),
  inactiveProductCount: Math.max(0, Number(preview.inactiveProductCount || 0)),
  manualProductCount: Math.max(0, Number(preview.manualProductCount || 0)),
  ifoodProductCount: Math.max(0, Number(preview.ifoodProductCount || 0)),
  otherProductCount: Math.max(0, Number(preview.otherProductCount || 0)),
  merchantCount: Math.max(0, Number(preview.merchantCount || 0)),
  canDelete: preview.canDelete === true && Number(preview.activeProductCount || 0) > 0,
});
